export default __webpack_public_path__ + "static/media/1882.96f60f1f.png";